import { render, staticRenderFns } from "./StaffRolesCard.vue?vue&type=template&id=543a6052&"
import script from "./StaffRolesCard.vue?vue&type=script&lang=js&"
export * from "./StaffRolesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports